export default (theme) => ({
  root: {
    margin: theme.spacing(3, 0),
  },
  buttonsWrapper: {
    marginTop: theme.spacing(2),
  },
})
